/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Contract_NoteInputs */



/**
* | output |
* | --- |
* | "This customer is on a contract. The plan, seats and add-ons are fixed for the whole term and cannot be changed here — contact oneAI to amend the agreement." |
*
* @param {Partner_Manage_Contract_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_contract_note = /** @type {((inputs?: Partner_Manage_Contract_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Contract_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Kunde hat einen Vertrag. Tarif, Plätze und Zusatzmodule sind für die gesamte Laufzeit festgelegt und können hier nicht geändert werden — wenden Sie sich an oneAI, um die Vereinbarung anzupassen.")
	return /** @type {LocalizedString} */ ("This customer is on a contract. The plan, seats and add-ons are fixed for the whole term and cannot be changed here — contact oneAI to amend the agreement.")
});